import { createContext } from 'react';

import { ProgramsContextProps } from './types';

const INITIAL_STATE: ProgramsContextProps = {
  programs: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPrograms: () => {},
};

const ProgramsContext = createContext<ProgramsContextProps>(INITIAL_STATE);

const ProgramsConsumer = ProgramsContext.Consumer;
const ProgramsProvider = ProgramsContext.Provider;

export { ProgramsContext, ProgramsConsumer, ProgramsProvider };
